/**
 * One leg of a transfer candidate / group (Phase 3, §6.5). Shows the account,
 * booking date, signed amount and counterparty/purpose. A `role="user"` badge
 * flags a leg the user categorised (link warns rather than overwriting it).
 */
import { AmountText } from '../../components/ui/AmountText.tsx';
import { formatDate } from '../../lib/format.ts';
import type { TransferLegOut } from '../../lib/types.ts';

export function TransferLeg({ leg }: { leg: TransferLegOut }) {
  const subtitle = leg.counterparty_name ?? leg.purpose ?? null;
  return (
    <div className="min-w-0 flex-1 rounded-lg bg-slate-50 p-3 dark:bg-slate-900">
      <div className="flex items-center justify-between gap-2">
        <p className="truncate text-sm font-medium text-slate-900 dark:text-slate-100">
          {leg.account_name}
        </p>
        {leg.is_user_categorized ? (
          <span className="shrink-0 rounded-full bg-slate-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.06em] text-slate-600 dark:bg-slate-800 dark:text-slate-300">
            manuell
          </span>
        ) : null}
      </div>
      <div className="mt-1 flex items-baseline justify-between gap-2">
        <span className="text-xs tabular-nums text-slate-500 dark:text-slate-400">
          {formatDate(leg.booking_date)}
        </span>
        <AmountText value={leg.amount} className="text-sm" />
      </div>
      {subtitle ? (
        <p className="mt-1 truncate text-xs text-slate-500 dark:text-slate-400" title={subtitle}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
